import {
    InjectionToken,
} from '@angular/core';
export const INFO_TEXT_DATA = new InjectionToken<{}>('INFO_TEXT_DATA');


// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/helper/info-text-data.ts